<div style="overflow-y: auto; height: calc(100% - 92px); padding-bottom: 60px;">
    <div class="menuSection">
      <ul class='nav navbar-nav'>
        <li [routerLinkActive]="['link-active']" *ngFor="let item of items" class="nav-item">
          @if(item.children.length > 0){
          <a [routerLink]="['/' + item.path]" style="padding: 15px;" class="nav-link">
            <mat-icon>{{item.icon}}</mat-icon> <span style="vertical-align: middle; margin-left: 5px;">{{'turbo.app.mnu_' + item.path | translate: item.title}}</span>
          </a>
          <div *ngIf="item.children">
            <ng-container *ngFor="let child of item.children">
              <a *ngIf="!child.uri" [routerLinkActive]="['link-active']" [routerLink]="['/' + child.path]" style="display: block; padding-left: 44px;">
                <span style="vertical-align: middle; margin-left: 5px;">{{'turbo.app.mnu_' + child.path | translate: child.title}}</span>
              </a>
              <a *ngIf="child.uri" href="{{child.uri}}" target="{{child.target}}" style="display: block; padding-left: 44px;">
                <span style="vertical-align: middle; margin-left: 5px;">{{'turbo.app.mnu_' + child.path | translate: child.title}}</span>
              </a>
            </ng-container>
              
          </div>
          }
        </li>
      </ul>
    </div>
</div>
